(function () {
  // Save the original decode function
  const originalDecodeURIComponent = window.decodeURIComponent;

  // Replace the global decode function
  window.decodeURIComponent = function (encodedURIComponent) {
    try {
      return originalDecodeURIComponent(encodedURIComponent);
    } catch (e) {
      // In case of error, return the undecoded string
      console.warn('URI decoding error avoided:', e);
      return encodedURIComponent;
    }
  };

  // Intercept global errors related to cookies
  window.addEventListener('error', function (event) {
    if (event.error && (event.error instanceof URIError || event.error.toString().includes('URI') || event.error.toString().includes('cookie'))) {
      console.warn('Cookie error intercepted:', event.error);
      event.preventDefault();
      event.stopPropagation();
      return false;
    }
  }, true);

  // Intercept unhandled promise rejections
  window.addEventListener('unhandledrejection', function (event) {
    if (event.reason && (event.reason instanceof URIError || event.reason.toString().includes('URI') || event.reason.toString().includes('cookie'))) {
      console.warn('Unhandled promise rejection intercepted:', event.reason);
      event.preventDefault();
      event.stopPropagation();
      return false;
    }
  }, true);
})();